<template>
  <div class="custom-modal-size">
    <transition name="fade">
      <div v-if="stepSelected === 'duplicateOrNew'" id="duplicateOrNew">
        <div class="choice-duplicate-new">
            <BtnBigSquare 
              :msg="$t('duplicate')" 
              :iconBtn="'el-icon-document-copy '"
              @click.native="stepSelected = 'ChooseRefOF'">
            </BtnBigSquare>
            <BtnBigSquare 
              :msg="$t('new')"
              :iconBtn="'el-icon-document-add'"
              @click.native="stepSelected = 'form'">
            </BtnBigSquare>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="stepSelected === 'ChooseRefOF'" id="ChooseRefOF">
        <h2>OF list</h2>
        <el-table
          :data="collection.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
          height="350">
          <el-table-column
            label="Name">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
           <el-table-column
            label="Start">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ getReadableFormat(scope.row.start) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="End">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ getReadableFormat(scope.row.end) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Tags"
            prop="tags"
            width="180"
            :filters="convertTagsToFilterTag(tagsData)"
            :filter-method="filterTag">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-tag class="tag-margin-right" v-for="(tag, idx) in scope.row.tags" :key="idx" size="medium">{{ tag }}</el-tag>
              </div>
            </template>
          </el-table-column>
         <el-table-column
          align="right">
          <!-- eslint-disable-next-line -->
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="Type to search"/>
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">duplicate</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="stepSelected === 'form'" id="form">
        <CreateBeacon :beaconSelected="ofToDuplicate" :formTitle="formTitle" @closeForm="closeForm"></CreateBeacon>
      </div>
    </transition>
  </div>
</template>

<script>
import CreateBeacon from './CreateBeacon.vue'
import BtnBigSquare from '../BtnBigSquare.vue'
import DateTimeManipulation from '../../mixins/DateTimeManipulation'
import { tagList } from '../../data/dynamoDBSimulation'

export default {
  components: {
    CreateBeacon,
    BtnBigSquare
  },
  data() {
    return {
      steps: ['duplicateOrNew', 'ChooseRefOF', 'form'],
      stepSelected: 'duplicateOrNew',
      ofToDuplicate: {},
      tagsData: [],
      tableData: [],
      formTitle: 'Créeer un beacon',
      search: '',
    }
  },
  mounted()  {
    this.$store.dispatch('getProductionZones');
    this.tagsData = tagList;
  },
  computed : {
    collection() {
      return this.$store.getters.productionZones
    }
  },
  methods: {
    handleEdit(index, row) {
      this.ofToDuplicate = row;
      this.ofToDuplicate.name += ' - duplicate';
      this.stepSelected = 'form';
      this.formTitle = `Duplicate OF ${this.ofToDuplicate.name}`;
    },
    filterTag(value, row) {
      return row.tags.includes(value.toLowerCase());
    },
    convertTagsToFilterTag: function(tags) {
      let filterTag = [];
      tags.forEach( tag => filterTag.push({ text: tag, value: tag }));
      return filterTag;
    },
    closeForm: function() {
      this.$emit('closeForm', false);
    }
  },
  mixins: [DateTimeManipulation]
}
</script>

<style scoped>
.custom-modal-size {
  margin: auto;
}

.choice-duplicate-new {
  /* width: 80%;
  min-height: 20px; */
  margin: auto;
  /* background-color: aquamarine; */
  display: flex;
  justify-content: space-evenly;
 }

.choice-box {
  width: 200px;
  height: 200px;
  background-color: blueviolet;
}

.tag-margin-right {
  margin-right: 6px;
}

/* ANIMATIONS */

.fade-enter-active {
  transition-delay: 0.5s;
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>